export default {
      id: "qr-apple-usage",
      viewBox: "0 0 33 33",
      url: "/" + "images/icons.3.109.2.svg#qr-apple-usage",
      toString: function () {
        return this.url;
      }
    }